import Head from 'next/head'
import Seo, { SITE_URL } from '@comp/seo'

interface SolutionMetaProps {
  title: string
  description: string
  /** Route path without locale prefix, e.g. '/solutions/zero-trust'. */
  path: string
  /** Pass the page locale when the page is fully localized (bilingual). */
  locale?: string
  /** When true, emits EN/TR hreflang alternates and a locale-aware canonical. */
  bilingual?: boolean
}

export default function SolutionMeta({
  title,
  description,
  path,
  locale,
  bilingual = false,
}: SolutionMetaProps) {
  const basePath = bilingual && locale === 'tr' ? '/tr' : ''
  return (
    <>
      <Seo
        title={`${title} | Monofor`}
        description={description}
        path={`${basePath}${path}`}
      />
      {bilingual && (
        <Head>
          <link rel="alternate" hrefLang="en" href={`${SITE_URL}${path}`} />
          <link rel="alternate" hrefLang="tr" href={`${SITE_URL}/tr${path}`} />
          <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />
        </Head>
      )}
    </>
  )
}
